// extracted by mini-css-extract-plugin
module.exports = {"actorsWrapper":"MovieDetailsActorsView_actorsWrapper__N7JwX","actorRole":"MovieDetailsActorsView_actorRole__Vm65Z"};